var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGodUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.6875C9.86886 10.6875 11.7857 8.6748 11.7857 6.1875V2.31609C11.7857 1.8457 11.5095 1.42383 11.091 1.26141L8.25335 0.14502C8.01228 0.0483398 7.75446 0 7.5 0C7.24554 0 6.99107 0.0483398 6.74665 0.14502L3.91071 1.26141C3.49219 1.42383 3.21429 1.8457 3.21429 2.31609V6.1875C3.21429 8.67656 5.13281 10.6875 7.5 10.6875ZM4.82143 5.625H10.1786V6.1875C10.1786 7.73789 8.97656 9 7.5 9C6.02344 9 4.82143 7.73789 4.82143 6.1875V5.625ZM10.9554 10.9969L7.5 14.625L4.04464 10.9969C1.70324 11.7809 0 14.0643 0 16.7836C2.00893e-05 17.4551 0.519643 18 1.16049 18H13.8382C14.479 18 14.9987 17.4565 14.9987 16.7832C14.9699 14.066 13.2958 11.7809 10.9554 10.9969Z",
    fill: "#525969"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGodUser);
export default __webpack_public_path__ + "static/media/god_user.f62d198b32e6515b5c5a0ec66fa015ab.svg";
export { ForwardRef as ReactComponent };